<!-- PAGE TITLE
        ================================================== -->
<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>ARNI SCHOOL OF ART &HUMANITIES</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">Fashion Design</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>


<section class="pt-3">
    <div class="container">
        <h3 class="text-center text-primary">Courses</h3>
        <div class="row">
            <div class="col-md-12 col-lg-12 col-sm-12">
                <div class="event-schedule-table table-responsive">
                    <table class="table">
                        <thead>
                        <tr>
                            <th class="time">Post Graduate</th>
                            <th class="time">Under Graduate</th>
                            <th class="time">Diploma</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td class="time">Master in Fashion Designing</td>
                            <td class="time">Bachelor of Fashion Design</td>
                            <td class="time">Diploma in Fashion Designing</td>
                        </tr>
                        <tr>
                            <td class="time">Master in Interior Designing</td>
                            <td class="time">B.Des (Fashion)</td>
                            <td class="time">Diploma in Interior Designing</td>
                        </tr>
                        <tr>
                            <td class="time"></td>
                            <td class="time">Bachelor of Interior Design</td>
                            <td class="time"></td>
                        </tr>
                        <tr>
                            <td class="time"></td>
                            <td class="time">B.Des (Interior Design)</td>
                            <td class="time"></td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <h5 class="text-decoration-underline text-center">Designing</h5>

        <div class="row">
            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Bachelor of Fashion Design </b>
                    – The Bachelor of Fashion Design program at ARNI School of Art & Humanities is designed to nurture
                    creativity, technical skills, and industry knowledge in the field of fashion and apparel design. The
                    program blends theoretical learning with hands-on experience, preparing students for careers in
                    fashion design, styling, retail, and entrepreneurship.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 1</b></p>
                <ul>
                    <li> Introduction to Fashion Design</li>
                    <li> Basic Drawing and Sketching for Fashion</li>
                    <li> Elements and Principles of Design</li>
                    <li> Textile Science</li>
                    <li> Fashion Illustration and Presentation Techniques</li>
                    <li> Communication Skills and Soft Skills</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 2</b></p>
                <ul>
                    <li> Pattern-Making and Draping Techniques</li>
                    <li> Apparel Construction Techniques</li>
                    <li> Fashion and Textile Industry Overview</li>
                    <li> Computer-Aided Design (CAD) for Fashion</li>
                    <li> Fashion Marketing and Consumer Behavior</li>
                    <li> Workshop: Embroidery and Surface Ornamentation</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 3</b></p>
                <ul>
                    <li> Advanced Garment Construction</li>
                    <li> Fashion Styling and Image Consulting</li>
                    <li> Textile Dyeing and Printing Techniques</li>
                    <li> Fashion Accessories Design</li>
                    <li> Internship / Industry Exposure</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 4</b></p>
                <ul>
                    <li> Entrepreneurship in Fashion</li>
                    <li> Fashion Show Production and Event Planning</li>
                    <li> Fashion Forecasting and Trend Analysis</li>
                    <li> Final Year Project / Fashion Collection Development</li>
                    <li> Portfolio Development and Presentation</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 5</b></p>
                <ul>
                    <li> Knitwear</li>
                    <li> Manufacturing Technology</li>
                    <li> Leather Designing</li>
                    <li> Indian Art Appreciation</li>
                    <li> Internship/Project</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 6</b></p>
                <ul>
                    <li> Perspective Drawing</li>
                    <li> Textile Science</li>
                    <li> Surface Development Techniques</li>
                    <li> Styling</li>
                    <li> Viva Voce and Graduation Showcase</li>
                </ul>
            </div>

            <hr class="border-dashed border-2"/>

            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">B.Des (Fashion)</b>
                    – The Bachelor of Design (B.Des) in Fashion program at ARNI School of Art & Humanities is a
                    four-year
                    undergraduate course designed to develop creative, technical, and business skills in the fashion
                    industry. The program blends design innovation with sustainability, technology, and industry
                    exposure to prepare students for global fashion careers.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 1 </b> : Foundation of Fashion & Design
                </p>
                <ul>
                    <li> Fashion Illustration & Sketching – I</li>
                    <li> Model Drawing & Figure Analysis – I</li>
                    <li> Global Fashion & Textile Industry Overview</li>
                    <li> Fundamentals of Design – I</li>
                    <li> Introduction to Pattern Drafting – I</li>
                    <li> Basics of Garment Manufacturing – I</li>
                    <li> Textile Fundamentals – I</li>
                    <li> Fashion History – I</li>
                    <li> Digital Applications in Fashion – I</li>
                    <li> English Communication – I</li>
                    <li> Behavioral & Personality Development – I</li>
                    <li> Foreign Language – I</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 2 </b> : Fundamentals & Technical Skills
                </p>
                <ul>
                    <li> Advanced Fashion Illustration – II</li>
                    <li> Model Drawing & Creative Expression – II</li>
                    <li> Elements & Principles of Design – II</li>
                    <li> Pattern Drafting & Draping Techniques – II</li>
                    <li> Garment Manufacturing Techniques – II</li>
                    <li> Textile Science – II</li>
                    <li> Evolution of Fashion – II</li>
                    <li> Digital Fashion Technology – II</li>
                    <li> Environmental Awareness in Fashion</li>
                    <li> English Communication – II</li>
                    <li> Behavioral & Soft Skills – II</li>
                    <li> Foreign Language – II</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 3 </b> : Intermediate Level Design &
                    Business
                </p>
                <ul>
                    <li> Grading & Sizing in Fashion</li>
                    <li> Advanced Pattern Development</li>
                    <li> Apparel Construction – I</li>
                    <li> Textile Studies – III</li>
                    <li> Digital Fashion Design – III</li>
                    <li> Fashion Forecasting & Market Trends – I</li>
                    <li> Merchandising & Retail Strategies – I</li>
                    <li> Artistic Expression in Fashion Design</li>
                    <li> Professional Communication – I</li>
                    <li> Behavioral Studies – III</li>
                    <li> Foreign Language – III</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 4 </b> :Applied Fashion Techniques
                </p>
                <ul>
                    <li> Draping Techniques in Fashion Design</li>
                    <li> Apparel Construction – II</li>
                    <li> Garment Industry Quality Control</li>
                    <li> Digital Fashion Applications – IV</li>
                    <li> Advanced Merchandising & Retail Strategies – II</li>
                    <li> Fashion Trend Analysis – II</li>
                    <li> Cultural & Traditional Textiles</li>
                    <li> Mini Capstone Project</li>
                    <li> Business Communication in Fashion – II</li>
                    <li> Personality & Behavioral Development – IV</li>
                    <li> Foreign Language – IV</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 5 </b> : Industry Exposure & Specialization
                </p>
                <ul>
                    <li> Global Fashion Marketing Strategies – III</li>
                    <li> Professional Portfolio Development – I</li>
                    <li> Corporate Communication in Fashion – III</li>
                    <li> Behavioral & Industry Readiness – V</li>
                    <li> Foreign Language – V</li>
                    <li> Internship / Industry Project</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 6 </b> : Advanced Industry Practices
                </p>
                <ul>
                    <li> Advanced Marketing & Merchandising – IV</li>
                    <li> Portfolio Development in Fashion – II</li>
                    <li> Fashion Trends & Aesthetics</li>
                    <li> Media & Fashion Journalism</li>
                    <li> Corporate Communication in Fashion – IV</li>
                    <li> Behavioral Skills for Industry – VI</li>
                    <li> Foreign Language – VI</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 7 </b> : Material Studies & Advanced
                    Concepts
                </p>
                <ul>
                    <li> Fabric & Material Studies – I</li>
                    <li> Fashion Business & Retail Strategies – V</li>
                    <li> Professional Portfolio Development – III</li>
                    <li> Communication & Leadership in Fashion – V</li>
                    <li> Behavioral Science – VII</li>
                    <li> Foreign Language – VII</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 8 </b> : Capstone Project & Specialization
                </p>
                <ul>
                    <li> Advanced Fabric & Material Studies – II</li>
                    <li> Strategic Marketing & Branding in Fashion – VI</li>
                    <li> Specialized Portfolio Development (Menswear/Womenswear/Kidswear)</li>
                    <li> Major Industry Project / Thesis</li>
                    <li> Advanced Communication & Industry Relations – VI</li>
                    <li> Behavioral Studies & Leadership – VIII</li>
                    <li> Foreign Language – VIII</li>
                </ul>
            </div>

            <hr class="border-dashed border-2"/>

            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Bachelor of Interior Design </b>
                    – The Bachelor of Interior Design program at ARNI School of Art & Humanities is designed to equip
                    students with the creative, technical, and business skills required for a successful career in
                    interior design. This four-year undergraduate program blends aesthetics, functionality, and
                    sustainability to shape interior spaces that enhance human experiences.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 1 </b> : Foundation in Interior Design
                </p>
                <ul>
                    <li> Fundamentals of Interior Design</li>
                    <li> Basics of Architectural Drawing & Drafting</li>
                    <li> Elements & Principles of Design</li>
                    <li> Visual Communication & Presentation Techniques</li>
                    <li> History of Art & Architecture – I</li>
                    <li> Building Materials & Construction – I</li>
                    <li>Environmental Studies</li>
                    <li> Communication Skills – I</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 2 </b> : Design & Technical Development
                </p>
                <ul>
                    <li> Interior Space Planning & Design</li>
                    <li> Digital Design Tools & AutoCAD – I</li>
                    <li> History of Art & Architecture – II</li>
                    <li> Building Materials & Construction – II</li>
                    <li> Color Theory & Application</li>
                    <li> Furniture Design – I</li>
                    <li> Human Factors & Ergonomics</li>
                    <li> Communication Skills – II</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 3 </b> : Residential & Commercial Interiors
                </p>
                <ul>
                    <li> Residential Interior Design</li>
                    <li> Digital Design & AutoCAD – II</li>
                    <li> Interior Services (Plumbing, HVAC, Electrical)</li>
                    <li> Sustainable Design & Green Interiors</li>
                    <li> Building Materials & Construction – III</li>
                    <li> Furniture Design – II</li>
                    <li> Design Communication & Model Making</li>
                    <li> Behavioral Science – I</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 4 </b> : Retail & Hospitality Design
                </p>
                <ul>
                    <li> Retail & Commercial Interior Design</li>
                    <li> Lighting & Acoustics in Interiors</li>
                    <li> Interior Services & Smart Technology</li>
                    <li> Advanced Materials & Finishes</li>
                    <li> Digital Design & 3D Modeling – I</li>
                    <li> Traditional & Contemporary Design Styles</li>
                    <li> Behavioral Science – II</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 5 </b> : Institutional & Office Interiors
                </p>
                <ul>
                    <li> Office & Institutional Interior Design</li>
                    <li> Project Management in Interior Design</li>
                    <li> Sustainable & Eco-Friendly Interiors</li>
                    <li> Estimation, Costing & Budgeting</li>
                    <li> Digital Design & 3D Modeling – II</li>
                    <li> Advanced Furniture Design</li>
                    <li> Internship / Industry Exposure</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 6 </b> : Exhibition & Set Design
                </p>
                <ul>
                    <li> Exhibition & Event Space Design</li>
                    <li> Set & Stage Design Principles</li>
                    <li> Interior Landscaping & Outdoor Spaces</li>
                    <li> Business of Interior Design & Entrepreneurship</li>
                    <li> Professional Practice & Ethics</li>
                    <li> Research & Documentation in Interior Design</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 7 </b> : Advanced Specialization
                </p>
                <ul>
                    <li> Hospitality & Recreational Space Design</li>
                    <li>Smart & Adaptive Interior Spaces</li>
                    <li> Heritage Conservation & Restoration</li>
                    <li> Portfolio Development</li>
                    <li>Project Proposal & Research Methodology</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 8 </b> : Capstone Project & Industry
                    Integration
                </p>
                <ul>
                    <li> Major Interior Design Project (Residential / Commercial / Hospitality)</li>
                    <li> Industry Internship & Practical Training</li>
                    <li> Entrepreneurship & Business Strategies</li>
                    <li> Professional Communication & Client Handling</li>
                    <li> Final Portfolio Review & Presentation</li>
                </ul>
            </div>

            <hr class="border-dashed border-2"/>

            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">B.Des (Interior Design) </b>
                    – The Bachelor of Design (B.Des) in Interior Design at ARNI School of Art & Humanities is a
                    four-year undergraduate program that blends creativity, functionality, and sustainability in
                    designing interior spaces. This program equips students with in-depth knowledge of spatial planning,
                    design aesthetics, material selection, technology integration, and project management to create
                    functional and aesthetically pleasing interiors.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 1 </b> : Foundation of Interior Design
                </p>
                <ul>
                    <li> Introduction to Interior Design</li>
                    <li> Fundamentals of Design & Composition</li>
                    <li> Architectural Drawing & Drafting</li>
                    <li> Visual Communication & Presentation Techniques</li>
                    <li> History of Architecture & Interior Design – I</li>
                    <li>Building Materials & Construction – I</li>
                    <li> Environmental Studies</li>
                    <li> Communication Skills – I</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 2 </b> : Design Principles & Space Planning
                </p>
                <ul>
                    <li> Space Planning & Ergonomics</li>
                    <li> Color Theory & Application</li>
                    <li> Digital Design Tools & AutoCAD – I</li>
                    <li> History of Architecture & Interior Design – II</li>
                    <li> Building Materials & Construction – II</li>
                    <li> Furniture Design – I</li>
                    <li> Lighting & Acoustics in Interior Design</li>
                    <li> Communication Skills – II</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 3 </b> : Residential & Commercial Interiors
                </p>
                <ul>
                    <li> Residential Interior Design</li>
                    <li> Advanced AutoCAD & 3D Visualization – I</li>
                    <li> Interior Services (Plumbing, HVAC, Electrical)</li>
                    <li> Sustainable Interior Design Practices</li>
                    <li> Furniture Design – II</li>
                    <li>Building Materials & Construction – III</li>
                    <li>Communication Skills – III</li>
                    <li> Behavioral Science – I</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 4 </b> : Retail & Hospitality Interiors
                </p>
                <ul>
                    <li> Retail & Commercial Interior Design</li>
                    <li> Lighting Design & Application</li>
                    <li> Smart Technology & Interior Automation</li>
                    <li> Computer-Aided Interior Design – II</li>
                    <li> Advanced Furniture Design</li>
                    <li> Traditional & Contemporary Interior Styles</li>
                    <li> Behavioral Science – II</li>
                    <li> Foreign Language – I</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 5 </b> : Institutional & Office Interiors
                </p>
                <ul>
                    <li> Office & Institutional Interior Design</li>
                    <li> Estimation, Costing & Budgeting</li>
                    <li> Project Management in Interior Design</li>
                    <li> Interior Landscaping & Outdoor Spaces</li>
                    <li> Digital Design & 3D Modeling – III</li>
                    <li>Advanced Building Systems & Construction</li>
                    <li> Internship / Industry Exposure</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 6 </b> : Exhibition & Set Design
                </p>
                <ul>
                    <li>Exhibition & Event Space Design</li>
                    <li>Set & Stage Design</li>
                    <li> Interior Restoration & Conservation</li>
                    <li>Research & Documentation in Interior Design</li>
                    <li>Business of Interior Design & Entrepreneurship</li>
                    <li>Professional Practice & Ethics</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 7 </b> : Advanced Specialization
                </p>
                <ul>
                    <li>Sustainable & Adaptive Interior Spaces</li>
                    <li>Fashion Retail & Luxury Interiors</li>
                    <li>Heritage Conservation & Restoration</li>
                    <li>Portfolio Development & Branding</li>
                    <li>Project Proposal & Research Methodology</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 8 </b> : Capstone Project & Industry
                    Integration
                </p>
                <ul>
                    <li> Major Interior Design Project (Residential / Commercial / Hospitality)</li>
                    <li> Industry Internship & Practical Training</li>
                    <li>Entrepreneurship & Business Strategies</li>
                    <li>Professional Communication & Client Handling</li>
                    <li>Final Portfolio Review & Presentation</li>
                </ul>
            </div>

            <hr class="border-dashed border-2"/>

            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Master in Fashion Designing </b>
                    – The Master in Fashion Designing program at ARNI School of Art & Humanities is a comprehensive
                    two-year postgraduate course designed to nurture creative talents and transform students into future
                    leaders of the fashion industry. This program focuses on enhancing design skills, textile knowledge,
                    garment construction, and marketing strategies, while also promoting an understanding of sustainable
                    and ethical practices in the fashion world.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 1 </b>
                </p>
                <ul>
                    <li> Fashion Illustration & Design Techniques</li>
                    <li> History of Fashion & Costume Design</li>
                    <li> Textile Science & Fabric Studies</li>
                    <li> Apparel Construction & Pattern Making</li>
                    <li> Fashion Forecasting & Trend Analysis</li>
                    <li> Computer-Aided Fashion Design (CAD)</li>
                    <li> Research Methodology in Fashion</li>
                    <li> Elective I (Sustainable Fashion / Fashion Communication)</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 2 </b>
                </p>
                <ul>
                    <li> Advanced Draping Techniques</li>
                    <li> Fashion Marketing & Brand Management</li>
                    <li> Visual Merchandising & Retail Management</li>
                    <li> Innovative Textiles & Surface Ornamentation</li>
                    <li> Global Fashion & Cultural Studies</li>
                    <li> Luxury Fashion & Entrepreneurship</li>
                    <li> Portfolio Development & Presentation</li>
                    <li> Elective II (Fashion Styling / Digital Fashion Technology)</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 3</b>
                </p>
                <ul>
                    <li> Fashion Business & Supply Chain Management</li>
                    <li> Experimental Garment Construction</li>
                    <li> Fashion Journalism & Media Studies</li>
                    <li> Creative Fashion Branding & Advertising</li>
                    <li> Industry Internship / Live Project</li>
                    <li> Advanced Research in Fashion Design</li>
                    <li> Elective III (Ethical Fashion / Fashion Accessories Design)</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 4 </b>
                </p>
                <ul>
                    <li> Final Major Project / Fashion Collection Development</li>
                    <li> Runway & Exhibition Presentation</li>
                    <li> Professional Ethics & Legal Aspects in Fashion</li>
                    <li> Sustainable & Eco-friendly Fashion Innovations</li>
                    <li> Entrepreneurship & Fashion Start-up Strategies</li>
                    <li> Dissertation & Industry Report</li>
                </ul>
            </div>

            <hr class="border-dashed border-2"/>

            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Master in Interior Designing </b>
                    – The Master in Interior Designing program at ARNI School of Art & Humanities is a two-year,
                    postgraduate course that equips students with advanced knowledge and skills in designing functional,
                    aesthetically appealing, and sustainable interior spaces. Combining creativity, technical expertise,
                    and environmental considerations, this program prepares students to take on leadership roles in the
                    interior design industry.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 1</b>
                </p>
                <ul>
                    <li> Advanced Interior Design Concepts</li>
                    <li> Interior Space Planning & Layouts</li>
                    <li> Materials & Finishes in Interior Design</li>
                    <li> Design Fundamentals & Elements</li>
                    <li> Interior Design for Residential Spaces</li>
                    <li> Building Systems & Codes</li>
                    <li> Lighting Design for Interiors</li>
                    <li> Interior Design Studio I (Project Work)</li>
                    <li> Research Methodology in Interior Design</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 2</b>
                </p>
                <ul>
                    <li> Commercial & Office Space Design</li>
                    <li> Advanced Materials & Sustainable Practices</li>
                    <li> Furniture Design & Ergonomics</li>
                    <li> Interior Design for Retail & Hospitality</li>
                    <li> Colour Theory & Application in Interiors</li>
                    <li> Construction Detailing in Interior Design</li>
                    <li> Interior Design Studio II (Project Work)</li>
                    <li> Building Services & Environmental Design</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 3</b>
                </p>
                <ul>
                    <li> Architectural Interiors & Historic Preservation</li>
                    <li> Design Management & Project Coordination</li>
                    <li> Interior Branding & Visual Merchandising</li>
                    <li> Acoustics & Thermal Design in Interiors</li>
                    <li> Advanced Computer-Aided Design (CAD) Techniques</li>
                    <li> Smart & Sustainable Homes</li>
                    <li> Interior Design Studio III (Project Work)</li>
                    <li> Research in Interior Design Trends & Innovations</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 4</b>
                </p>
                <ul>
                    <li>Universal Design & Accessibility</li>
                    <li> Lighting & Electrical Systems in Interior Design</li>
                    <li> Interior Landscaping & Green Spaces</li>
                    <li> Integrated Design & Technology for Interiors</li>
                    <li> Interior Design Studio IV (Final Project)</li>
                    <li> Professional Practice & Ethics in Interior Design</li>
                    <li> Dissertation / Industry Internship / Live Project</li>
                </ul>
            </div>

            <hr class="border-dashed border-2"/>

            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Diploma in Fashion Designing </b>
                    – The Diploma in Fashion Designing at ARNI School of Art & Humanities is a comprehensive, one-year
                    program designed for individuals passionate about the world of fashion. This course provides a
                    perfect blend of creative, technical, and business skills, allowing students to develop into
                    professionals who can contribute to the ever-evolving fashion industry.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 1</b>
                </p>
                <ul>
                    <li> Fashion Design Fundamentals</li>
                    <li> Elements of Design (Color, Texture, Fabric, and Shape)</li>
                    <li> Fashion Illustration and Sketching</li>
                    <li> Textile Science and Fabric Studies</li>
                    <li> Basic Pattern Making</li>
                    <li> Sewing Techniques and Garment Construction</li>
                    <li> Introduction to Fashion History</li>
                    <li> Fashion Accessories Design</li>
                    <li> Visual Merchandising and Display</li>
                    <li> Computer-Aided Design (CAD) Introduction</li>
                    <li> Basic English and Communication Skills</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 2</b>
                </p>
                <ul>
                    <li> Advanced Fashion Illustration</li>
                    <li> Garment Construction and Draping Techniques</li>
                    <li> Fashion Textiles and Fabrics (Advanced Studies)</li>
                    <li> Pattern Making and Grading</li>
                    <li> Fashion Marketing and Merchandising</li>
                    <li> Fashion Forecasting and Trends</li>
                    <li> Fashion Photography and Styling</li>
                    <li> Computer-Aided Design (CAD) Advanced</li>
                    <li> Design Portfolio Development</li>
                    <li> Professional Ethics and Practices in Fashion Design</li>
                    <li> Fashion Journalism and Blogging</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 3</b>
                </p>
                <ul>
                    <li> Sustainable Fashion Design</li>
                    <li> Advanced Pattern Making and Draping</li>
                    <li> Fashion Design for Special Occasions and Couture</li>
                    <li> Branding and Identity in Fashion</li>
                    <li> Fashion Business and Entrepreneurship</li>
                    <li> Retail Management in Fashion</li>
                    <li> Apparel Production and Quality Control</li>
                    <li> Fashion Show Planning and Execution</li>
                    <li> Textile Dyeing and Printing Techniques</li>
                    <li> Internship / Live Project</li>
                    <li> Advanced Fashion Communication</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 4</b>
                </p>
                <ul>
                    <li> Ethical and Sustainable Fashion</li>
                    <li> Fashion Show Styling and Coordination</li>
                    <li> Advanced Fashion Marketing and Digital Branding</li>
                    <li> Fashion Design for Men and Kidswear</li>
                    <li> Global Fashion Industry Trends and Innovations</li>
                    <li> Advanced Portfolio Development</li>
                    <li> Fashion Photography: Conceptual Styling</li>
                    <li> Fashion Product Development and Sampling</li>
                    <li> Industry Internship/Professional Practice</li>
                    <li> Capstone Project / Final Design Collection</li>
                </ul>
            </div>

            <hr class="border-dashed border-2"/>

            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Diploma in Interior Designing </b>
                    – The Diploma in Interior Designing at ARNI School of Art & Humanities is a dynamic, hands-on
                    program designed for those passionate about creating functional and aesthetically pleasing interior
                    spaces. This comprehensive course blends creativity with technical skills, equipping students with
                    the knowledge and expertise to design spaces that are not only visually appealing but also
                    functional and sustainable.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 1</b>
                </p>
                <ul>
                    <li> Introduction to Interior Design</li>
                    <li> Design Principles and Elements</li>
                    <li> Drawing and Sketching Techniques for Interiors</li>
                    <li> Materials and Finishes for Interiors</li>
                    <li> History of Interior Design</li>
                    <li> Introduction to Space Planning</li>
                    <li> Basic Computer-Aided Design (CAD)</li>
                    <li> Colour Theory and Application</li>
                    <li> Environmental Studies in Interior Design</li>
                    <li> Professional Practices in Interior Design</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 2</b>
                </p>
                <ul>
                    <li> Advanced Space Planning and Layouts</li>
                    <li> Furniture Design and Construction</li>
                    <li> Lighting Design and its Impact on Interiors</li>
                    <li> Interior Design for Residential Spaces</li>
                    <li> Textiles and Upholstery in Interior Design</li>
                    <li> Sustainable Interior Design</li>
                    <li> Computer-Aided Design (CAD) Advanced Techniques</li>
                    <li> Visual Merchandising and Retail Interiors</li>
                    <li> Building Materials and Construction Systems</li>
                    <li> Professional Ethics in Interior Design</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 3</b>
                </p>
                <ul>
                    <li> Commercial Interior Design</li>
                    <li> Interior Design for Hospitality and Corporate Spaces</li>
                    <li> Advanced Lighting Techniques and Control</li>
                    <li> Ergonomics and Human Factors in Interior Design</li>
                    <li> Soft Furnishings and Window Treatments</li>
                    <li> Interior Design Trends and Innovations</li>
                    <li> 3D Modeling and Visualization for Interiors</li>
                    <li> Project Management for Interior Design</li>
                    <li> Costing and Budgeting in Interior Design</li>
                    <li> Interior Design Presentation Skills</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 4</b>
                </p>
                <ul>
                    <li> Sustainable and Green Interior Design Practices</li>
                    <li> Interior Design for Healthcare and Educational Institutions</li>
                    <li> Advanced Furniture and Layout Design</li>
                    <li> Construction Detailing for Interiors</li>
                    <li> Interior Renovation and Restoration</li>
                    <li> Design for Specialized Spaces (e.g., Retail, Offices, Showrooms)</li>
                    <li> Portfolio Development and Presentation</li>
                    <li> Internship / Live Project</li>
                    <li> Capstone Project</li>
                </ul>
            </div>


        </div>

    </div>
</section>
